// 🚧 أنواع/سكيمات Zod مشتركة
// ستُملأ بالتفصيل في المرحلة 1+2+3
// أمثلة لما سيُضاف:
// - LoginInputSchema
// - RegisterInputSchema
// - PropertyInputSchema
// - AuctionInputSchema
// - PaginationSchema
// - ApiResponseSchema<T>

import { z } from 'zod';

// مثال أوّلي: استجابة API موحّدة
export const ApiSuccessSchema = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    success: z.literal(true),
    data,
    message: z.string().optional(),
  });

export const ApiErrorSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  fieldErrors: z.record(z.array(z.string())).optional(),
});

export type ApiSuccess<T> = { success: true; data: T; message?: string };
export type ApiError = z.infer<typeof ApiErrorSchema>;
export type ApiResponse<T> = ApiSuccess<T> | ApiError;

// Pagination
export const PaginationQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(50).default(12),
});
export type PaginationQuery = z.infer<typeof PaginationQuerySchema>;
